/* eslint-disable global-require */
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import type { SearchAllContentORCIDPublicationHit } from '../../../../SearchAllContent/types';
import ButtonWrapper from '../../../../ButtonWrapper';
import Card from '../../../../Card';
import Citation from './Citation';

import './style.scss';

export interface MetaSearchORCIDPublicationHitProps {
  hit: SearchAllContentORCIDPublicationHit;
}

const MetaSearchORCIDPublicationHit: React.FC<MetaSearchORCIDPublicationHitProps> = (props) => {
  const { hit } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'custom_entities.nioz_publication_orcid' });

  const citationId = hit.orcid_publication_external_id?.[0];
  const title = hit.orcid_publication_title[0];
  const year = hit.orcid_publication_year?.[0];
  const citation = hit.orcid_publication_citation?.[0];
  const citationType = hit.orcid_publication_citation_type?.[0];

  let citationUrl = hit.orcid_publication_external_id_url?.[0];
  // A DOI always starts with `10.`
  if (!citationUrl && citationId?.startsWith('10.')) {
    citationUrl = `https://doi.org/${citationId}`;
  }

  const classes = c('ORCIDPublicationCard', {
    [`ORCIDPublicationCard__year__${year ?? ''}`]: year !== undefined,
  });

  return (
    <Card className={classes} withLink={false}>
      <Card.Content>
        <h2 className="ORCIDPublicationCard__year">{year}</h2>
        <div className="ORCIDPublicationCard__wrapper">
          <Card.Subtitle
            subtitle={(
              <>
                {(citation && citationType === 'bibtex') ? (
                  <Citation
                    id={hit.orcid_publication_id[0]}
                    citation={citation}
                  />
                ) : (
                  <span className="ORCIDPublicationCard__title">{title}</span>
                )}
                {citationUrl && (
                  <ButtonWrapper
                    href={citationUrl}
                    type="textual"
                    className="ORCIDPublicationCard__citationUrl"
                  >
                    {t('card_link_title')}
                  </ButtonWrapper>
                )}
              </>
            )}
          />
        </div>

      </Card.Content>
    </Card>
  );
};

export default MetaSearchORCIDPublicationHit;
